<h1 mat-dialog-title class="title-content">
    <mat-icon class="close_button" (click)="onNoClick()">cancel</mat-icon>
    <div class="title-spacing">{{data.Title}}</div>
    <mat-divider></mat-divider>
</h1>
<div mat-dialog-content class="body-content">
    <div markdown [data]="mdservice.mdcontent"></div>
</div>